import React from "react";
import { Link } from "react-router-dom";
import { businessInfo, applianceMeta } from "../constants";
import { Phone, Mail, MapPin, MessageCircle, Instagram, Facebook, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0b1220] text-white pt-16 pb-8 mt-4">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 bg-[#e30613] text-white grid place-items-center font-bold text-xl rounded-md">R</div>
              <div className="leading-tight">
                <div className="font-display text-lg font-semibold">Revive Solutions</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-white/60">Authorised Elica Service</div>
              </div>
            </div>
            <p className="text-sm text-white/60 leading-relaxed mb-5">
              Authorised Elica service provider based in Wanowrie, Pune. Doorstep repair, cleaning, installation & maintenance for all Elica kitchen appliances.
            </p>
            <div className="flex items-center gap-3">
              <a href={businessInfo.whatsapp} target="_blank" rel="noreferrer" className="w-9 h-9 grid place-items-center border border-white/15 hover:bg-[#25D366] hover:border-[#25D366] rounded transition-colors"><MessageCircle className="w-4 h-4" /></a>
              <a href="#" aria-label="Facebook" className="w-9 h-9 grid place-items-center border border-white/15 hover:bg-[#e30613] hover:border-[#e30613] rounded transition-colors"><Facebook className="w-4 h-4" /></a>
              <a href="#" aria-label="Instagram" className="w-9 h-9 grid place-items-center border border-white/15 hover:bg-[#e30613] hover:border-[#e30613] rounded transition-colors"><Instagram className="w-4 h-4" /></a>
              <a href="#" aria-label="Youtube" className="w-9 h-9 grid place-items-center border border-white/15 hover:bg-[#e30613] hover:border-[#e30613] rounded transition-colors"><Youtube className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold mb-5">Appliance Services</div>
            <ul className="space-y-2.5 text-sm text-white/60">
              {Object.values(applianceMeta).map((a) => (
                <li key={a.slug}><Link to={a.route} className="hover:text-[#e30613] transition-colors">Elica {a.title} Service</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold mb-5">Quick Links</div>
            <ul className="space-y-2.5 text-sm text-white/60">
              <li><Link to="/book-service" className="hover:text-[#e30613] transition-colors">Book a Service</Link></li>
              <li><Link to="/service-charges" className="hover:text-[#e30613] transition-colors">Service Charges</Link></li>
              <li><Link to="/service-areas" className="hover:text-[#e30613] transition-colors">Service Areas</Link></li>
              <li><Link to="/about" className="hover:text-[#e30613] transition-colors">About Us</Link></li>
              <li><Link to="/faq" className="hover:text-[#e30613] transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-[#e30613] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold mb-5">Get in touch</div>
            <ul className="space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#e30613]" /><span>{businessInfo.address}</span></li>
              <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#e30613]" /><a href={`tel:${businessInfo.phone}`} className="hover:text-white transition-colors">{businessInfo.phoneDisplay}</a></li>
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#e30613]" /><a href={`mailto:${businessInfo.email}`} className="hover:text-white transition-colors break-all">{businessInfo.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} Revive Solutions. Authorised Elica Service Provider. All rights reserved.</p>
          <div className="flex items-center gap-6 text-xs text-white/50">
            <Link to="/faq" className="hover:text-white">FAQ</Link>
            <Link to="/contact" className="hover:text-white">Contact</Link>
            <Link to="/service-areas" className="hover:text-white">Service Areas</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
